import Swiper, { Autoplay, FreeMode, Navigation, Pagination, Thumbs } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';

window.addEventListener("load", function(){
	if ( typeof Swiper !== "undefined" ){
		new Swiper('.school-scroller', {
			modules: [Navigation],
			navigation: {
				nextEl: '.school-scroller-block__nav-btn--next',
				prevEl: '.school-scroller-block__nav-btn--prev',
			},
			loop: true,
			centeredSlides: true,
			spaceBetween: 30,
			slidesPerView: 2,
			breakpoints: {
				600: {
					slidesPerView: 4,
					spaceBetween: 30
				},
				1120: {
					slidesPerView: 6,
					spaceBetween: 30
				},
			},
		});

		var sliderThumbnails = new Swiper('.gallery-thumbnails', {
			slidesPerView: 4,
			spaceBetween: 20,
			freeMode: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
		});

		var slider = new Swiper('.gallery-slider', {
			modules: [Navigation, Thumbs],
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			thumbs: {
				swiper: sliderThumbnails
			}
		});

	}
});
